"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiCheckboxOverrides = void 0;
var core_1 = require("@material-ui/core");
var createMuiCheckboxOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            padding: "calc(" + spacing(4) + "px - 0.75rem)",
            '& [class*="MuiSvgIcon-root"]': {
                stroke: palette.text.secondary,
                transition: transitions.create(["fill", "stroke", "color", "background-color"], {
                    duration: transitions.duration.shorter,
                }),
            },
        },
        colorPrimary: {
            '& [class*="MuiSvgIcon-root"]': {
                stroke: palette.text.secondary,
            },
            '&&$indeterminate [class*="MuiSvgIcon-root"], &&$checked [class*="MuiSvgIcon-root"]': {
                color: palette.common.white,
                fill: palette.primary.main,
                stroke: palette.background.default,
            },
            "&:hover, &&$checked:hover, &.Mui-focusVisible": {
                backgroundColor: palette.divider,
            },
            '&.Mui-focusVisible [class*="MuiSvgIcon-root"]': {
                stroke: palette.text.primary,
            },
            "&:active, &&$checked:active": {
                backgroundColor: core_1.fade(palette.text.primary, 0.24),
            },
            "&$disabled": {
                color: palette.text.primary,
            },
        },
        disabled: {
            opacity: palette.action.disabledOpacity,
        },
    });
};
exports.createMuiCheckboxOverrides = createMuiCheckboxOverrides;
//# sourceMappingURL=MuiCheckbox.js.map